var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 11,
    viewBox: "0 0 340 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.844,
    y: 7.00391,
    width: 48,
    height: 1,
    fill: "#FBBF24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.844 7.504L170.024 11.008L173.156 7.528L169.952 4L166.844 7.504Z",
    fill: "#F59E0B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181.156,
    y: 7.00391,
    width: 48,
    height: 1,
    fill: "#FBBF24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSection);
export default __webpack_public_path__ + "static/media/HeaderSection.b81e5f351a09188e6055cbb229eb462d.svg";
export { ForwardRef as ReactComponent };